import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { DatastoreCollection } from '@freelancer/datastore';
import { Article, ArticlesCollection } from '@freelancer/datastore/collections';
import { Feature } from '@freelancer/feature-flags';
import { CardSize } from '@freelancer/ui/card';
import { trackById, trackByValue } from '@freelancer/ui/helpers';
import { LinkHoverColor } from '@freelancer/ui/link';
import { ListItemPadding, ListItemType } from '@freelancer/ui/list-item';
import { Margin } from '@freelancer/ui/margin';
import { FontType } from '@freelancer/ui/text';
import * as Rx from 'rxjs';

@Component({
  selector: 'app-user-profile-articles',
  template: `
    <ng-container *ngIf="articles$ | flAsync as articles; else loading">
      <fl-card *ngIf="articles && articles.length > 0" [size]="CardSize.SMALL">
        <fl-card-header-title i18n="Recently community articles card title">
          Recent Community Articles
        </fl-card-header-title>

        <ng-container *ngIf="articles && articles.length > 0">
          <fl-list
            [outerPadding]="false"
            [padding]="ListItemPadding.XSMALL"
            [type]="ListItemType.NON_BORDERED"
          >
            <fl-list-item
              *ngFor="
                let article of articles | slice: 0:displayAmount;
                trackBy: trackById
              "
            >
              <app-user-profile-articles-item
                [article]="article"
              ></app-user-profile-articles-item>
            </fl-list-item>
          </fl-list>
        </ng-container>
      </fl-card>
    </ng-container>

    <ng-template #loading>
      <fl-card [size]="CardSize.SMALL">
        <fl-card-header-title i18n="Recent community articles card title">
          Recent Community Articles
        </fl-card-header-title>
        <fl-list
          [outerPadding]="false"
          [padding]="ListItemPadding.XSMALL"
          [type]="ListItemType.NON_BORDERED"
        >
          <fl-list-item *ngFor="let item of [0, 1, 2]; trackBy: trackByValue">
            <fl-loading-text [rows]="1" [padded]="false"></fl-loading-text>
          </fl-list-item>
        </fl-list>
      </fl-card>
    </ng-template>
  `,
  styleUrls: ['./user-profile-articles.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserProfileArticlesComponent implements OnInit {
  CardSize = CardSize;
  Feature = Feature;
  FontType = FontType;
  LinkHoverColor = LinkHoverColor;
  ListItemPadding = ListItemPadding;
  ListItemType = ListItemType;
  Margin = Margin;
  trackById = trackById;
  trackByValue = trackByValue;

  displayAmount = 5;

  @Input() articlesCollection: DatastoreCollection<ArticlesCollection>;

  articles$: Rx.Observable<readonly Article[]>;

  ngOnInit() {
    this.articles$ = this.articlesCollection.valueChanges();
  }
}
